import { Token } from '@lumino/coreutils';
import SW_URL from './service-worker?text';
/**
 * The token for the ServiceWorker.
 */
export const IServiceWorkerManager = new Token('@jupyterlite/server-extension:IServiceWorkerManager');
export const WORKER_NAME = `${SW_URL}`.split('/').slice(-1)[0];
//# sourceMappingURL=tokens.js.map